import React from "react";
import { FaGamepad } from "react-icons/fa";
import {MdNewspaper} from 'react-icons/md'
import { MdOutlineMovieFilter } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaHandsPraying } from 'react-icons/fa6'
import "../App.css";

const Home = () => {

  const homeData = [
    {
      id:1,
      url:'news',
      logo:<MdNewspaper size={60} />,
      text:'News',
      bgColor:'#f83c55'
    },
    {
      id:2,
      url:'gameHome',
      logo:<FaGamepad size={60}/>,
      text:'Games',
      bgColor:'#6D00D9'
    },
    {
      id:3,
      url:'spiritual',
      logo:<FaHandsPraying size={60}/>,
      text:'Spiritual',
      bgColor:'#FD8427'
    },
    {
      id:4,
      url:'movies',
      logo:<MdOutlineMovieFilter size={60}/>,
      text:'Movies',
      bgColor:'#0071D9'
    }
  ]

  return (
    <div className="w-full h-full flex flex-row items-center py-20 lg:pt-0 screen-background">
      <div className="w-11/12 mx-auto grid grid-cols-4 flex-wrap lg:flex-nowrap gap-x-6 gap-y-6">
        {
          homeData?.map((data) => (
            <Link
              to={data.url}
              key={data.id} 
              className="h-full w-full flex flex-col gap-y-5 justify-center items-center mx-auto rounded-xl hover:cursor-pointer hover:scale-105 text-white transition-all duration-200"
            >
              <div style={{backgroundColor:data.bgColor}} className={`p-6 rounded-3xl`}>{data.logo}</div>
              <div className="text-3xl font-semibold">{data.text}</div>
            </Link>
          ))
        }
      </div>
    </div>
  );
};

export default Home;
